module.exports = __webpack_public_path__ + "static/media/28.7d0ec58e.png";